import { GET_ALL_DOCUMENTS_API } from "../../constants/api";
import axios from "../fetch/fetch";

export const getAllDocumentsAPI = async (): Promise<any[]> => {
  const response = await axios.get(GET_ALL_DOCUMENTS_API);
  return response.data;
};
